import { RadiationNewEvent, RadiationNotif } from 'core/models';
import React, { createContext, useContext, useState } from 'react';

interface RadiationNotifsContextType {
    radiationNotifs: RadiationNotif[];
    setRadiationNotifs: (radiationNotifs: RadiationNotif[]) => void;
    addRadiationNotif: (radiationNotif: RadiationNotif[]) => void;
    isOnGoingCancellation: (params: { codAffilie: string; codSouscrip: string }) => boolean;
    removeRadiationNotif: (id: string) => void;
    radiationNewEvent: RadiationNewEvent;
    setRadiationNewEvent: (radiationNewEvent: RadiationNewEvent) => void;
    isRadiationNotifInList: (radiationNotif: RadiationNotif) => boolean;
}

const RadiationNotifsContext = createContext<RadiationNotifsContextType>({
    radiationNotifs: [],
    setRadiationNotifs: () => {},
    addRadiationNotif: () => {},
    isOnGoingCancellation: () => false,
    removeRadiationNotif: () => {},
    radiationNewEvent: null,
    setRadiationNewEvent: () => {},
    isRadiationNotifInList: () => false,
});

interface Props {
    children: React.ReactNode;
}

export function RadiationNotifsProvider({ children }: Props) {
    const [radiationNotifs, setRadiationNotifs] = useState<RadiationNotif[]>([]); // list of cancellation notification
    const [radiationNewEvent, setRadiationNewEvent] = useState<RadiationNewEvent>(null); // radiationNewEvent = response traiment from mercure

    const addRadiationNotif = (newRadiationNotifs: RadiationNotif[]) => {
        newRadiationNotifs.forEach((radiationNotif: RadiationNotif) => {
            const isInList = isRadiationNotifInList(radiationNotif);
            if (!isInList) {
                const newRadiationNotifs = [...radiationNotifs, radiationNotif];
                setRadiationNotifs(newRadiationNotifs);
            }
        });
    };

    const removeRadiationNotif = async (id: string) => {
        setRadiationNotifs((radiationNotifs) => {
            const newRadiationNotifs = radiationNotifs.filter((o) => o.id !== id);
            return [...newRadiationNotifs];
        });
    };

    const isRadiationNotifInList = (radiationNotif: RadiationNotif) => {
        const notif = radiationNotifs.find((r) => r.id === radiationNotif.id);
        return notif ? true : false;
    };

    const isOnGoingCancellation = ({ codAffilie, codSouscrip, codContrat }: { codAffilie: string; codSouscrip: string; codContrat: string }): boolean => {
        const contractIds = radiationNotifs.flatMap((entry) => entry.data.contracts.map((contract) => contract.idContract));
        const foundEntry = radiationNotifs.find((entry) => entry.data.codAffilie === codAffilie && entry.data.codSouscrip === codSouscrip && contractIds.includes(codContrat));
        return Boolean(foundEntry);
    };

    return (
        <RadiationNotifsContext.Provider
            value={{
                radiationNotifs,
                setRadiationNotifs,
                addRadiationNotif,
                isOnGoingCancellation,
                removeRadiationNotif,
                radiationNewEvent,
                setRadiationNewEvent,
                isRadiationNotifInList,
            }}
        >
            {children}
        </RadiationNotifsContext.Provider>
    );
}

export const useRadiationNotifsContext = (): RadiationNotifsContextType => useContext(RadiationNotifsContext);
